import state from '../zviz3/state';

export const checkConditions = function(conditions){
    if(! (conditions instanceof Array)){
        conditions = [conditions];
    }
    for(const condition of conditions){
        if(condition.type === 'and'){
            let result = true;
            for(const c of condition.conditions){
                result = checkConditions([c]);
                if(! result){
                    break;
                }
            }
            return result;
        }else if(condition.type === 'nor'){
            for(const c of condition.conditions){
                // none of the conditions should be true
                if(checkConditions([c])){
                    return false;
                }
            }
            return true;
        }else if(condition.type === 'group'){
            return checkConditions(condition.conditions);
        }else if(condition.type === 'equal'){
            if(state.get('answers.' + condition.variable) === condition.value){
                return true;
            }
        }else if(condition.type === 'not_equal'){
            if(state.get('answers.' + condition.variable) !== condition.value){
                return true;
            }
        }else if(condition.type === 'includes'){
            const val = state.get('answers.' + condition.variable);
            if(val && val.indexOf(condition.value) !== -1){
                return true;
            }
        }
    }
    return false;
}




// WEBPACK FOOTER //
// ./src/helpers/conditions.js